import ReactHtmlParser from 'react-html-parser';
import useAnimations from '../../helpers/animations';

function About({ data }) {
    useAnimations({
        sections: [
            {
                section: 'section.about-section',
                animations: [
                    { target: 'div.right-column .text-block' },
                    { target: 'div.left-column .image-block:first-child .image img', scale: 1 },
                    { target: 'div.right-column .image-block .image img', scale: 1 },
                    { target: 'div.left-column .image-block:nth-child(2) .image img', scale: 1 },
                    { target: 'div.left-column .image-block:first-child h4' },
                    { target: 'div.left-column .image-block:first-child p' },
                    { target: 'div.left-column .image-block:nth-child(2) h4' },
                    { target: 'div.left-column .image-block:nth-child(2) p' },
                    { target: 'div.right-column .image-block h4' },
                    { target: 'div.right-column .image-block p' }
                ]
            },
        ]
    });

    const [header_title_part1, header_title_part2, header_title_part3] =
        data?.about_header?.title ? data.about_header.title.split('-') : [];

    return (
        <section className="about-section hp bg-light">
            <div className="container">
                <div className="left-column d-flex">
                    <div className="image-block d-flex">
                        <div className="image">
                            <img src={data?.about_1.img_url} alt="team-members" />
                        </div>
                        <h4 className="font-dark">{data?.about_1.title}</h4>
                        {ReactHtmlParser(data?.about_1.description)}
                        <button>
                            <a href={data?.about_1.button_link} className="d-flex">
                                <span>{data?.about_1.button_name}</span>
                                <img src={data?.about_1.button_icon} alt="arrow-right" />
                            </a>
                        </button>
                    </div>
                    <div className="image-block d-flex">
                        <div className="image">
                            <img src={data?.about_3.img_url} alt="team-member" />
                        </div>
                        <h4 className="font-dark">{data?.about_3.title}</h4>
                        {ReactHtmlParser(data?.about_3.description)}
                        <button>
                            <a href={data?.about_3.button_link} className="d-flex">
                                <span>{data?.about_3.button_name}</span>
                                <img src={data?.about_3.button_icon} alt="arrow-right" />
                            </a>
                        </button>
                    </div>
                </div>
                <div className="right-column d-flex">
                    <div className="text-block">
                        <h1 className="font-dark">
                            {header_title_part1}<span>{header_title_part2}</span>{header_title_part3}
                        </h1>
                        {ReactHtmlParser(data?.about_header.description)}
                    </div>
                    <div className="image-block d-flex">
                        <div className="image">
                            <img src={data?.about_2.img_url} alt="product" />
                        </div>
                        <h4 className="font-dark">{data?.about_2.title}</h4>
                        {ReactHtmlParser(data?.about_2.description)}
                        <button>
                            <a href={data?.about_2.button_link} className="d-flex">
                                <span>{data?.about_2.button_name}</span>
                                <img src={data?.about_2.button_icon} alt="arrow-right" />
                            </a>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;